module.exports = __webpack_public_path__ + "img/pethouse58.e9b3c0c6.jpg";